
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skiferie",
      function () {
        return require("private-next-pages/[region]/skiferie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skiferie"])
      });
    }
  